<template>
  <div class="_display:flex _align-items:center">
    {{ data.data }}
    <div v-if="data.name==='#'" class="_display:flex">
      <svg
        am-icon
        style="fill: var(--color--primary-55);"
        class="_margin-left:1/2"
        @click="setModalRow(data.rowIndex)"
      >
        <use xlink:href="@/assets/icons.svg#open-modal"></use>
      </svg>
      <svg
        v-if="!partId.toString().includes('new') && !partId.toString().includes('copy')"
        am-icon
        style="fill: var(--color--primary-55);"
        class="_margin-left:1/2"
        @click="makeCopy()"
      >
        <use xlink:href="@/assets/icons.svg#copy"></use>
      </svg>
      <svg
        v-if="
          isRemovable ||
          $store.getters.isAdmin ||
          partId.toString().includes('new') ||
          partId.toString().includes('copy')
        "
        am-icon
        style="fill: var(--color--primary-55);"
        class="_margin-left:1/2"
        @click="
          partId.toString().includes('new') || partId.toString().includes('copy')
          ? delNewPart() : isDeleteModal = true"
      >
        <use xlink:href="@/assets/icons.svg#delete2"></use>
      </svg>
      <div v-if="isDeleteModal">
        <i-modal v-model="isDeleteModal">
          <template #header>
            Delete this Part ({{partId}})?
          </template>
          <div
            class="_display:flex _justify-content:space-between"
            am-changed-part-buttons
          >
            <i-button @click="del">
              Yes
            </i-button>
            <i-button color="primary" @click="isDeleteModal = false">No</i-button>
          </div>
        </i-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'StaticItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isDeleteModal: false
  }),
  computed: {
    ...mapGetters('partCategories', ['isRemovable']),
    ...mapState('filter', ['filteredParts']),
    partId () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts.find(el => {
        return el.rowIndex === this.data.rowIndex && el.name === 'id'
      })?.data
    }
  },
  methods: {
    ...mapMutations('parts', [
      'setModalRow', 'DEL_CHANGED_PARTS_PART', 'DEL_ROW_DATA', 'DEL_CHANGED_IMAGE_IN_PART'
    ]),
    ...mapActions('parts', ['delPart', 'getParts', 'copyPart']),
    ...mapActions('filter', ['filterPart']),
    async makeCopy () {
      await this.copyPart({
        rowIndex: this.data.rowIndex,
        subtable: this.$route.params.subtable
      })
      const tableWrapper = document.querySelector('[am-table-wrapper]')
      const table = document.querySelector('[am-table]')
      tableWrapper.scrollTo({
        top: table.getBoundingClientRect().height,
        behavior: 'smooth'
      })
      if (this.filteredParts) this.filterPart({ subtable: this.$route.params.subtable })
    },
    async del () {
      this.isDeleteModal = false
      const isDel = await this.delPart({
        id: this.partId,
        subtable: this.$route.params.subtable
      })
      if (isDel) {
        this.DEL_ROW_DATA({ rowIndex: this.data.rowIndex, subtable: this.$route.params.subtable })
      }
    },
    delNewPart () {
      this.DEL_CHANGED_PARTS_PART({
        subtable: this.$route.params.subtable,
        id: this.partId,
        isNewDel: true
      })
      this.DEL_CHANGED_IMAGE_IN_PART({
        subtable: this.$route.params.subtable,
        partId: this.partId
      })
      this.DEL_ROW_DATA({ rowIndex: this.data.rowIndex, subtable: this.$route.params.subtable })
      if (this.filteredParts) this.filterPart({ subtable: this.$route.params.subtable })
    }
  }
}
</script>

<style lang="scss">

</style>
